var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotivation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "kxnwnieeva"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.188235 0 0 0 0 0.470588 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#kxnwnieeva)",
    transform: "translate(-867 -386)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M36.835 29.555c-.399 0-.846.065-1.363.207-3.11 1.362-6.338 2.051-9.597 2.051-5.535 0-9.289-2.02-9.326-2.04-.018-.01-.036-.016-.054-.022-.42-.114-.901-.183-1.322-.193v.003c-.016-.003-.032-.005-.047-.005l-.05-.001c-.024 0-.046.004-.069.01-.766.037-1.358.33-1.76.872-1.04 1.398-.404 3.96-.372 4.084 2.386 7.422 10.23 7.998 12.577 7.998.332 0 .533-.011.535-.013.029.002.229.013.562.013 2.347 0 10.19-.576 12.582-8.013.028-.11.674-2.708-.391-4.102-.431-.564-1.072-.85-1.905-.85zm-.043 4.469c-1.916 5.855-8.34 6.31-10.264 6.31-.257 0-.408-.01-.412-.01-.038-.002-.076-.004-.115-.004-.038 0-.076.002-.11.004-.021.001-.172.01-.419.01-1.923 0-8.347-.455-10.256-6.289-.183-.771-.203-1.92.043-2.24.033-.043.168-.061.27-.063.162.003.432.026.675.081 1.017.508 4.597 2.09 9.675 2.09 3.36 0 6.686-.701 9.849-2.074.266-.066.5-.1.694-.1.13 0 .282.017.319.065.248.322.227 1.469.051 2.22zM16.201 18.8c0-1.717 1.375-3.11 3.07-3.11 1.696 0 3.07 1.393 3.07 3.11 0 1.718-1.374 3.11-3.07 3.11-1.695 0-3.07-1.393-3.07-3.11zm13.923 0c0-1.717 1.377-3.11 3.072-3.11 1.696 0 3.07 1.393 3.07 3.11 0 1.718-1.374 3.11-3.07 3.11-1.695 0-3.072-1.393-3.072-3.11zM42.648 52H9.353C4.375 52 .325 47.9.325 42.858V9.142C.325 4.1 4.375 0 9.353 0h33.294c4.979 0 9.028 4.101 9.028 9.142v33.716c0 5.041-4.05 9.142-9.027 9.142zM9.353 4.301c-2.635 0-4.78 2.171-4.78 4.84v33.716c0 2.669 2.145 4.84 4.78 4.84h33.294c2.635 0 4.78-2.171 4.78-4.84V9.142c0-2.669-2.145-4.84-4.78-4.84H9.353z",
    transform: "translate(867.5 386)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivation);
export default __webpack_public_path__ + "static/media/motivation.dc3c848fb95aa61890e5af5bfbe1c61c.svg";
export { ForwardRef as ReactComponent };